import React, { useEffect, useState } from 'react';
import { trackEvent } from './analytics';

const GATest = () => {
  const [testResults, setTestResults] = useState({
    scriptLoaded: false,
    gtagExists: false,
    dataLayerExists: false,
    measurementId: null,
  });

  useEffect(() => {
    // Wait for GA to load
    const checkGA = setInterval(() => {
      if (typeof window.gtag !== 'undefined') {
        setTestResults({
          scriptLoaded: true,
          gtagExists: typeof window.gtag !== 'undefined',
          dataLayerExists: typeof window.dataLayer !== 'undefined',
          measurementId: 'G-NCM0MQM9BN',
        });
        clearInterval(checkGA);
      }
    }, 500);

    return () => clearInterval(checkGA);
  }, []);

  const sendTestEvent = () => {
    trackEvent('ga_test_event', {
      test_time: new Date().toISOString(),
      test_source: 'manual_test',
    });
    alert('Test event sent! Check your GA Real-Time reports in 30-60 seconds.');
  };

  return (
    <div className="min-h-screen bg-gray-50 py-20">
      <div className="max-w-2xl mx-auto px-4">
        <div className="bg-white rounded-2xl shadow-lg p-8">
          <h1 className="text-3xl font-bold text-carbon mb-6">
            Google Analytics Test Page
          </h1>

          <div className="space-y-4 mb-8">
            <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
              <span className="font-semibold">GA Script Loaded:</span>
              <span className={testResults.scriptLoaded ? 'text-green-600' : 'text-red-600'}>
                {testResults.scriptLoaded ? '✅ Yes' : '❌ No'}
              </span>
            </div>

            <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
              <span className="font-semibold">gtag Function:</span>
              <span className={testResults.gtagExists ? 'text-green-600' : 'text-red-600'}>
                {testResults.gtagExists ? '✅ Exists' : '❌ Not Found'}
              </span>
            </div>

            <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
              <span className="font-semibold">dataLayer:</span>
              <span className={testResults.dataLayerExists ? 'text-green-600' : 'text-red-600'}>
                {testResults.dataLayerExists ? '✅ Exists' : '❌ Not Found'}
              </span>
            </div>

            <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
              <span className="font-semibold">Measurement ID:</span>
              <span className="text-gray-700 font-mono text-sm">
                {testResults.measurementId || 'Not configured'}
              </span>
            </div>
          </div>

          <button
            onClick={sendTestEvent}
            className="w-full bg-golden text-carbon px-8 py-4 rounded-lg text-lg font-bold hover:bg-golden/90 transition-all"
          >
            Send Test Event to Google Analytics
          </button>

          <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <h3 className="font-semibold text-blue-900 mb-2">How to verify:</h3>
            <ol className="list-decimal list-inside space-y-2 text-sm text-blue-800">
              <li>Click the "Send Test Event" button above</li>
              <li>Go to Google Analytics: analytics.google.com</li>
              <li>Click "Reports" → "Realtime"</li>
              <li>Wait 30-60 seconds</li>
              <li>You should see your test event appear</li>
            </ol>
          </div>

          <div className="mt-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
            <h3 className="font-semibold text-yellow-900 mb-2">Troubleshooting:</h3>
            <ul className="list-disc list-inside space-y-2 text-sm text-yellow-800">
              <li>Disable ad blockers (they block Google Analytics)</li>
              <li>Check you're viewing the correct GA4 property</li>
              <li>Data can take 24-48 hours to appear in standard reports</li>
              <li>Real-time reports show data within 30-60 seconds</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GATest;
